import Button from '@/common/components/Button'
import { formatCurrency } from '@/common/utils/formatters'
import { useFormContext } from 'react-hook-form'
import { ConsumptionValidationSchema } from '../schemas/create.schema'
import EssentialInformationForm from './EssentialInformationForm'
import ProductsForm from './ProductsForm'

interface TabInformationProps {
  activeTab: number
  handleTabChange: (tabIndex: number) => void
  clearForm: (exceptCardIdentifier?: boolean) => void
}

const TabInformation = ({ activeTab, handleTabChange, clearForm }: TabInformationProps) => {
  const {
    watch,
  } = useFormContext<ConsumptionValidationSchema>()

  const watchTotalAmount = watch('total_amount')

  return (
    <>
      <div className="flex gap-6 grow max-h-[calc(100vh-192px)] overflow-y-auto">
        <div className="basis-1/2 h-full">
          <EssentialInformationForm
            clearForm={clearForm}
          />
        </div>

        <div className="basis-1/2 h-full">
          <ProductsForm />
        </div>
      </div>

      <div className="flex items-center justify-end gap-4">
        <div>
          <p className="text-[14px] font-light italic">Valor total</p>

          <p className="text-[18px] font-bold">{formatCurrency(watchTotalAmount || 0)}</p>
        </div>

        <div>
          <Button name="go_to_consumption_resume_tab" type="button" onClick={() => handleTabChange(activeTab + 1)}>
            Ver resumo
          </Button>
        </div>
      </div>
    </>
  )
}

export default TabInformation
